/* istanbul ignore file */
export const PAGE_SIZE_CANDIDATES = 12;
